<template>
  <div class="two">
    <div class="left" style="flex: 1;">
      <div class="tit">耗电信息(kWh)</div>
      <div class="ul">
        <div class="li">
          <div class="num">225856.0</div>
          <div class="name">今年耗电量</div>
          <div class="percentage"><img src="./components/5.png" alt="">12.2%</div>
        </div>
        <div class="li">
          <div class="num">56892.0</div>
          <div class="name">本月耗电量</div>
          <div class="percentage percentage2"><img src="./components/8.png" alt="">60.0%</div>
        </div>
        <div class="li">
          <div class="num">2568.0</div>
          <div class="name">本周耗电量</div>
          <div class="percentage percentage2"><img src="./components/8.png" alt="">58.2%</div>
        </div>
        <div class="li">
          <div class="num">284.0</div>
          <div class="name">今日耗电量</div>
          <div class="percentage"><img src="./components/5.png" alt="">35.8%</div>
        </div>
      </div>
    </div>
    <div class="right left" style="flex: 2;">
      <div class="t" style="padding-bottom: 0;">
        <div class="tit">
          <span>告警事件</span>
          <div class="line"><router-link to="events">查看更多</router-link></div>
        </div>
        <div class="box">
          <vchart class="vchart" ref='vchart'></vchart>
          <table class="table" border="0">
            <thead>
              <tr class="tr">
                <td scope="col" style="width:100px">设备名称</td>
                <td scope="col" align="center">告警等级</td>
                <td scope="col">告警内容</td>
                <td scope="col">告警时间</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="i in 5" :key="i" class="tbody">
                <td scope="row" class="pp">{{i}}号空调外机</td>
                <td scope="row" align="center"><el-tag type="success" size="mini">消息</el-tag></td>
                <td scope="row" class="pp">机器停机不工作机器停机不工作</td>
                <td scope="row" class="pp" style="color: #666;">04/02 12:00</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import vchart from '../../components/module/Charts/chart.vue';//echart图
  import webMap from "@/page/webMap/webMap.vue";
  import left from "./left.vue";
  export default {
    components: {
      webMap,
      left,
      vchart
    },
    data () {
      return {
        roundOption3: {
          title: {
            text: '2326',
            subtext: '告警总数',
            left: '48%',
            top: '38%',
            textAlign: 'center',
            subtextStyle: {
              color: '#666',
              fontSize: 13,
              lineHeight: 0,
            },
            textStyle: {                  // 图例的公用文本样式。
              fontSize: 20,
              color: '#000',
            }
          },
          legend: {
            icon: "roundRect", //  这个字段控制形状  类型包括 circle， ，roundRect，triangle，diamond，pin，arrow，none
            itemWidth: 12, // 设置宽度
            itemHeight: 12, // 设置高度   
            bottom: '1',
            formatter: function(name) {
              return name;
            },
            textStyle: {                      // 图例的公用文本样式。
              fontSize: 13,
              color: '#000'
            }
          },

          tooltip: {
            trigger: 'item',
            formatter: '{b}: {c}(台)  ({d}%)'
          },
          series: [
            {
              type: 'pie',
              label: {
                show: false,
              },
              data: [
                {
                  value: 10,
                  name: '已处理'
                },
                {
                  value: 20,
                  name: '处理中'
                },{
                  value: 20,
                  name: '未处理'
                },
              ],
              color: ["#00ac3e","#005dff",'#ccc'],
              radius: ['56%','70%'],
              center: ['50%','45%'],
            }
          ]
        },

        nowScale: 50, //当前缩放倍率
        token: '', //token
        ids: [],
        svgPath: '',
      }
    },

    mounted () {
      this.$refs.vchart.setData(this.roundOption3,true);
    },
    destroyed () {

    },
    methods: {

    }
  }
</script>

<style lang="scss" scoped>
  .box {
    .table {
      flex: 1;
      margin-right: 15px;
    }

    a,
    p,
    label,
    input,
    textarea,
    li,
    u,
    table,
    th {
      background-color: #fff;
    }

    table {
      border-collapse: collapse;
    }

    table {
      border: 1px solid #ebebeb;
    }

    .tbody {
      border-top: 1px solid #ebebeb;
    }

    .tr {
      background-color: #F7F9FA;

      td {
        padding: 8px;
        white-space: nowrap;
      }
    }

    .pp {
      padding-left: 8px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      max-width: 200px;
    }

  }

  .ul {
    display: flex;
    flex-wrap: wrap;

    .li {
      width: calc(50% - 12px);
      margin-right: 12px;
      border-radius: 4px;
      box-sizing: border-box;
      /* 自动布局 */
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 12px 20px;
      background: #F7F9FA;
      margin-bottom: 12px;

      .num {
        /* 自动布局子元素 */
        font-family: Arial;
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 2px;
        color: #1A1A1A;
      }

      .name {
        /* 自动布局子元素 */
        font-family: Microsoft YaHei;
        font-size: 13px;
        font-weight: normal;
        line-height: normal;
        color: #666;
        margin-bottom: 10px;
      }

      .percentage {
        /* 自动布局子元素 */
        font-family: Microsoft YaHei;
        font-size: 14px;
        font-weight: normal;
        line-height: normal;
        color: #FF0000;
        display: flex;
        align-items: center;

        img {
          margin-right: 4px;
        }
      }

      .percentage2 {
        color: #009030;
      }
    }
  }

  .two {
    display: flex;
    margin-top: 12px;

    .box {
      display: flex;
    }

    .left {
      background-color: #fff;
      border-radius: 4px;
      padding-left: 12px;
    }

    .right {
      margin-left: 12px;
      width: auto;
    }
  }

  .one {
    display: flex;
    margin-top: 12px;

    .right {
      background-color: #fff;
      margin-left: 12px;
      border-radius: 4px;

      .map {
        position: relative;
        margin-right: 12px;
      }
    }
  }

  .left {
    .t {
      background-color: #fff;
      padding-left: 12px;
      margin-bottom: 12px;
      overflow: hidden;
      border-radius: 4px;
      padding-bottom: 20px;
    }
  }

  .tit {
    height: 18px;
    font-family: Microsoft YaHei;
    font-size: 14px;
    font-weight: bold;
    color: #1A1A1A;
    margin-top: 12px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding-right: 20px;

    .line {
      height: 17px;
      font-family: Microsoft YaHei;
      font-size: 13px;
      font-weight: normal;
      color: #666;
      cursor: pointer;

      a {
        color: inherit;
        text-decoration: none;
      }
    }
  }

  .vchart {
    max-width: 270px;
    height: 200px;
  }
</style>